export default function videoIsLandscape(str) {
  return str.includes("LAN");
}